<template>
  <v-card class="card-container">
    <div class="main-toolbar">
      <div class="icon-back">
        <v-img
          src="../../../assets/figmaIcons/white/servOrder.svg"
          max-width="55%"
        ></v-img>
      </div>

      <span class="main-toolbar-title">{{ $t('Automação') }}</span>

      <v-spacer></v-spacer>
    </div>

    <div class="d-flex">
      <v-spacer></v-spacer>
      <v-btn class="secondary-button ma-1" depressed to="/manageAutomation">
        Adicionar
      </v-btn>
    </div>

    <v-data-table
      :headers="headers"
      :items="data"
      :items-per-page="pageSize"
      class="main-table"
      hide-default-footer
      mobile-breakpoint="0"
    >
      <template #[`item.active`]="{ item }">
        <div class="d-flex justify-center">
          <v-switch
            class="ma-2 mr-0"
            v-model="item.active"
            inset
            :hint="item.active ? 'Ativo' : 'Inativo'"
            persistent-hint
            @change="changeStatus(item)"
            :color="item.active ? 'secondary' : 'error'"
          ></v-switch>
        </div>
      </template>
      <template #[`item.openBasedOn`]="{ item }">
        <span>{{
          openBasedOnOptions[item.openBasedOn]
            ? openBasedOnOptions[item.openBasedOn].text
            : 'Sem registro'
        }}</span>
      </template>
      <template #[`item.repeatPeriod`]="{ item }">
        <span>{{
          repeatPeriodOptions[item.repeatPeriod]
            ? repeatPeriodOptions[item.repeatPeriod].text
            : 'Sem registro'
        }}</span>
      </template>

      <template #[`item.actions`]="{ item }">
        <div class="d-flex align-center justify-center">
          <v-btn
            class="ma-2"
            small
            color="#f5f5f5"
            dark
            :to="`/detailAutomation?id=${item.id}`"
            depressed
          >
            <v-icon color="#bbcf20">mdi-eye-outline</v-icon>
          </v-btn>

          <v-btn
            class="ma-2"
            color="#0F3565"
            dark
            :to="`/manageAutomation?id=${item.id}`"
            depressed
            small
          >
            <v-icon dark> mdi-pencil-outline </v-icon>
          </v-btn>
        </div>
      </template>
    </v-data-table>

    <div class="pagination mx-2">
      <div class="item-pagination block-one">
        <v-menu bottom offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-bind="attrs"
              v-on="on"
              class="btn"
              depressed
              color="#C0C0C0"
              small
            >
              qtd: {{ pageSize }}
            </v-btn>
          </template>
          <v-list>
            <v-list-item
              v-for="(size, i) in sizes"
              :key="i"
              @click="pageSize = size"
            >
              <v-list-item-title>{{ size }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
        <div class="registros" v-if="data.length">
          <span> 1 - {{ data.length }} de {{ pager.totalItems }} </span>
          <br />
        </div>
      </div>

      <div class="item-pagination block-two">
        <v-pagination
          class="pagination-item"
          v-model="page"
          :length="pager.totalPages"
          :total-visible="5"
        ></v-pagination>
      </div>
    </div>
  </v-card>
</template>

<script>
import ApiService from '../../../services/ApiService'

export default {
  name: 'OrderAutomation',

  data() {
    return {
      data: [],
      headers: [
        {
          text: '',
          align: 'center',
          value: '',
          sortable: false,
        },
        {
          text: 'Status',
          align: 'center',
          value: 'active',
          sortable: false,
        },
        {
          text: 'Nome',
          align: 'center',
          value: 'name',
          sortable: false,
        },
        {
          text: 'Abertura baseada em',
          align: 'center',
          value: 'openBasedOn',
          sortable: false,
        },
        {
          text: 'Repetição',
          align: 'center',
          value: 'repeatPeriod',
          sortable: false,
        },
        {
          text: 'Ações',
          align: 'center',
          value: 'actions',
          sortable: false,
        },
      ],
      openBasedOnOptions: [
        {
          text: 'Data de solicitação',
          value: 0,
        },
        {
          text: 'Data de fechamento',
          value: 1,
        },
      ],
      repeatPeriodOptions: [
        {
          text: 'Diária',
          value: 0,
        },
        {
          text: 'Semanal',
          value: 1,
        },
        {
          text: 'Quinzenal',
          value: 2,
        },
        {
          text: 'Mensal',
          value: 3,
        },
      ],
      loading: false,
      apiService: new ApiService(),
      page: 1,
      pageSize: 10,
      sizes: [10, 30, 90, 180],
      pager: {},
    }
  },

  created() {
    this.list()
  },

  methods: {
    changeStatus(item) {
      const model = {
        id: item.id,
        active: item.active,
      }

      this.apiService.post('orderAutomation/change-status', model)
    },

    list() {
      this.loading = true

      const institution = JSON.parse(localStorage.getItem('institution'))

      const model = {
        institutionId: institution.id,
        page: this.page,
        pageSize: this.pageSize,
      }

      this.apiService.get('orderAutomation/list', model).then((response) => {
        this.data = response.content.data
        this.pager = response.content.pager
      })
    },
  },

  watch: {
    pageSize() {
      this.list()
    },

    page() {
      this.list()
    },
  },
}
</script>

<style scoped></style>
